import { render, staticRenderFns } from "./buriedModal.vue?vue&type=template&id=7109df5c&scoped=true&"
import script from "./buriedModal.vue?vue&type=script&lang=js&"
export * from "./buriedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7109df5c",
  null
  
)

export default component.exports